import { render } from "./NisabaSave.vue?vue&type=template&id=4e2eac21&scoped=true"
import script from "./NisabaSave.vue?vue&type=script&lang=js"
export * from "./NisabaSave.vue?vue&type=script&lang=js"

import "./NisabaSave.vue?vue&type=style&index=0&id=4e2eac21&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2eac21"]])

export default __exports__